import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Autocomplete, Backdrop, Box, Button, CircularProgress, Container, Snackbar, Stack, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getUsuarios } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import AddTransaccionComponents from "../../../components/AddTransaccionComponents";
import TransaccionDataClienteComponents from "../../../components/TransaccionDataClienteComponents";
import { optionsEmailVerificado } from "../../../constantes/constantes";
import { CssTextField } from "../../../styles/styles";
import AddTransaccionVerificarComponents from "./components/AddTransaccionVerificarComponents";



function CrearTransaccionPage() {
    const [name, setName] = useState('');
    const [apellido, setApellido] = useState('');
    const [cedula, setCedula] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [fechaNacimiento, setFechaNacimiento] = useState(null);
    const [fechaNacimientoBackend, setFechaNacimientoBackend] = useState('');
    const [verificarUsuario, setVerificarUsuario] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('success');
    const [datosCompletos, setDatosCompletos] = useState(false);
    const [fechaActual, setFechaActual] = useState(new Date());
    const [fechaActualBackend, setFechaActualBackend] = useState('');

    const [cantidadItems, setCantidadItems] = useState(0);
    const [observacion, setObservacion] = useState('');
    const [items, setItems] = useState('');




    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);

    const navigate = useNavigate();



    useEffect(() => {
        if (stateToken) {
            handleListarUsuarios();

            let fecha = new Date();

            //obtener la fecha en formato YYYY-MM-DD
            let fechaBackend = fecha.toISOString().split('T')[0];
            setFechaActualBackend(fechaBackend);

            //obtener la fecha en formato DD/MM/YYYY
            let fechaActual = fecha.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            setFechaActual(fechaActual);
        }
    }, [stateToken]);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.token, 1, 10)
            .then((response) => {
                console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                    setLoading(true);
                } else {
                    setDataUsuarios([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataUsuarios([]);
                setLoading(true);
            });
    };



    //=============================================funcion para capturar el name y cedula
    const handleName = (e) => {
        setName(e);
    }

    //=============================================funcion para capturar el apellido
    const handleApellido = (e) => {
        setApellido(e);
    }

    //=============================================funcion para capturar el cedula
    const handleCedula = (e) => {
        setCedula(e);
    }

    //=============================================funcion para capturar el email
    const handleEmail = (e) => {
        setEmail(e);
    }

    //=============================================funcion para capturar el telefono
    const handleTelefono = (e) => {
        setTelefono(e);
    }

    //=============================================funcion para capturar el direccion
    const handleDireccion = (e) => {
        setDireccion(e);
    }

    //=============================================funcion para capturar la cantidad de items
    const handleCantidadItems = (e) => {
        setCantidadItems(e);
    }

    //=============================================funcion para capturar el observacion
    const handleObservacion = (e) => {
        setObservacion(e);
    }

    //=============================================funcion para seleccionar el item
    const handleItems = (event) => {
        console.log("event", event);
        setItems(event);
    };







    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaNacimiento = (event) => {
        // console.log("event", event);
        setFechaNacimiento(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaNacimientoBackend(fecha);
    };


    //==============================================funcion para verificar el usuario
    const handleVerificarUsuario = () => {
        console.log("handleGuardar");

        if (cedula.trim() === '') {
            setMensaje('Ingrese la cédula');
            setSeverity('warning');
            setOpen(true);

        } else {
            setCargando(true);

            setTimeout(() => {

                setVerificarUsuario(true);
                setCargando(false);


            }, 2000);

        }

    };


    //==============================================funcion para guardar el usuario
    const handleGuardar = () => {
        console.log("handleGuardar");

        if (name.trim() === '') {
            setMensaje('Ingrese el nombre');
            setSeverity('warning');
            setOpen(true);

        } else if (apellido.trim() === '') {
            setMensaje('Ingrese el apellido');
            setSeverity('warning');
            setOpen(true);

        } else if (cedula.trim() === '') {
            setMensaje('Ingrese la cédula');
            setSeverity('warning');
            setOpen(true);

        } else if (email.trim() === '') {
            setMensaje('Ingrese el email');
            setSeverity('warning');
            setOpen(true);

        } else if (telefono.trim() === '') {
            setMensaje('Ingrese el telefono');
            setSeverity('warning');
            setOpen(true);

        } else if (direccion.trim() === '') {
            setMensaje('Ingrese la direccion');
            setSeverity('warning');
            setOpen(true);

        } else if (fechaNacimientoBackend.trim() === '') {
            setMensaje('Seleccione la fecha de nacimiento');
            setSeverity('warning');
            setOpen(true);

        } else {
            setCargando(true);

            setTimeout(() => {
                setDatosCompletos(true);
                // setVerificarUsuario(false);

                setCargando(false);
                // setName('');
                // setApellido('');
                // setCedula('');
                // setEmail('');
                // setTelefono('');
                // setDireccion('');
                // setFechaNacimiento(null);
                // setFechaNacimientoBackend('');

                setMensaje('Usuario creado correctamente');
                setSeverity('success');
                setOpen(true);

                setTimeout(() => {
                    navigate('/app/admin/atc/historial');
                }, 1500);

            }, 2000);

        }
    };

    //==============================================funcion para cancelar la transaccion
    const handleCancelar = () => {
        setVerificarUsuario(false);
        setDatosCompletos(false);
        setName('');
        setApellido('');
        setCedula('');
        setEmail('');
        setTelefono('');
        setDireccion('');
        setFechaNacimiento(null);
        setFechaNacimientoBackend('');

    }




    //==============================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };


    //==============================================habilitar completar el formulario de usuario
    const handleVolverEditar = () => {
        setDatosCompletos(false);
        setVerificarUsuario(true);

    }



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">


                        {verificarUsuario ? (
                            <div>
                                {datosCompletos ? (
                                    <div>

                                        <TransaccionDataClienteComponents
                                            name={name}

                                            apellido={apellido}

                                            cedula={cedula}

                                            email={email}

                                            telefono={telefono}

                                            direccion={direccion}

                                            fechaNacimiento={fechaNacimiento}

                                            handleVolverEditar={handleVolverEditar}
                                        />
                                    </div>
                                ) : (
                                    <AddTransaccionComponents
                                        name={name}
                                        handleName={handleName}

                                        apellido={apellido}
                                        handleApellido={handleApellido}

                                        cedula={cedula}
                                        handleCedula={handleCedula}

                                        email={email}
                                        handleEmail={handleEmail}

                                        telefono={telefono}
                                        handleTelefono={handleTelefono}

                                        direccion={direccion}
                                        handleDireccion={handleDireccion}


                                        fechaNacimiento={fechaNacimiento}
                                        handleFechaNacimiento={handleFechaNacimiento}

                                        handleGuardar={handleGuardar}
                                        handleCancelar={handleCancelar}
                                    />
                                )}
                            </div>
                        ) : (
                            <AddTransaccionVerificarComponents
                                cedula={cedula}
                                handleCedula={handleCedula}
                                handleVerificarUsuario={handleVerificarUsuario}
                            />
                        )}

                        {datosCompletos && (
                            <div style={{
                                backgroundColor: PaletaColor.BLANCO,
                                borderRadius: Padding.P1,
                                padding: Padding.P3,
                            }}>
                                <Box sx={{ width: '100%' }}>

                                    <div>
                                        <Typography variant={'h6'} style={{ fontWeight: 'bold' }}>
                                            Registrar Transacción
                                        </Typography>
                                    </div>

                                    <div style={{ marginTop: Padding.P2 }} >
                                        <div>
                                            <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                                Fecha
                                            </Typography>

                                            <Typography variant={'subtitle1'} style={{}}>
                                                {fechaActual}
                                            </Typography>
                                        </div>
                                    </div>





                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: Padding.P2 }}>
                                        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1 }}>

                                                <div>
                                                    <Typography variant={'subtitle1'} style={{ marginBottom: Padding.P1 }}>
                                                        Items
                                                    </Typography>
                                                </div>

                                                <Autocomplete
                                                    disablePortal
                                                    options={optionsEmailVerificado}
                                                    sx={{ width: "95%" }}
                                                    renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                                    onInputChange={(event, newInputValue) => {
                                                        handleItems(newInputValue);
                                                    }}
                                                    value={items}
                                                />
                                            </div>


                                            <div style={{ flex: 1 }}>
                                                <div>
                                                    <Typography variant={'subtitle1'} style={{}}>
                                                        Observación
                                                    </Typography>
                                                </div>

                                                <CssTextField
                                                    value={observacion}
                                                    onChange={(e) => handleObservacion(e.target.value)}
                                                    variant="outlined"
                                                    margin="normal"
                                                    fullWidth
                                                    label="Observación"
                                                    autoCapitalize='none'
                                                    autoCorrect={false}
                                                    style={{
                                                        marginTop: Padding.P1,
                                                        width: '95%'
                                                    }}
                                                />

                                            </div>


                                            <div style={{ flex: 1 }}>
                                                <div>
                                                    <Typography variant={'subtitle1'} style={{}}>
                                                        Cantidad
                                                    </Typography>
                                                </div>

                                                <CssTextField
                                                    value={cantidadItems}
                                                    onChange={(e) => handleCantidadItems(e.target.value)}
                                                    variant="outlined"
                                                    type="number"
                                                    margin="normal"
                                                    fullWidth
                                                    label="Cantidad"
                                                    autoCapitalize='none'
                                                    autoCorrect={false}
                                                    style={{
                                                        marginTop: Padding.P1,
                                                        // width: '95%'
                                                    }}
                                                />

                                            </div>

                                        </div>
                                    </div>


                                    <Stack direction="row" spacing={5} style={{ marginTop: Padding.P5 }}>
                                        <Button variant="contained"
                                        // onClick={handleGuardar}
                                        >
                                            Crear
                                        </Button>

                                        <Button variant="outlined" onClick={handleCancelar}>
                                            Cancelar
                                        </Button>
                                    </Stack>

                                </Box>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    </div>
                )}


                <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>

                <Backdrop open={cargando} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>

            </div>
        </HeaderCustom>
    );
}

export default CrearTransaccionPage;